export const allVideos = [
    {
        id: 'video_00',
        title: '科普视频样片',
        description: '',
        author: '科普视频样片',
        organization: '科普视频样片',
        url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/科普视频样片.mp4',
        projectTheme: '无',
        poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746934512633.jpg'
    },
  {
    id: 'video_01',
    title: '母亲节最温暖的礼物：守护 妈妈的"骨"气人生',
    description: '',
    author: '夏荣林',
    organization: '天津市天津医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/01-夏荣林-天津市天津医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746934512633.jpg'
  },
  {
    id: 'video_02',
    title: '护骨安康，母爱绵长',
    description: '',
    author: '李伟阳',
    organization: '吉林省人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/02-李伟阳-吉林省人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935517216.jpg'
  },
  {
    id: 'video_03',
    title: '医路有你健康相随',
    description: '',
    author: '律国强',
    organization: '本溪市第一人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/04-律国强-本溪市第一人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935600014.jpg'
  },
  {
    id: 'video_04',
    title: '别让骨质疏松偷走妈妈的优雅人生',
    description: '',
    author: '朱江锋',
    organization: '苏州永鼎医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/05-朱江锋-苏州永鼎医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935645223.jpg'
  },
  {
    id: 'video_05',
    title: '关注女性骨骼健康',
    description: '',
    author: '高聿同',
    organization: '山东省立医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/06-高聿同-山东省立医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935697777.jpg'
  },
  {
    id: 'video_06',
    title: '母亲节：关注妈妈的"隐形健康杀手"——骨质疏松',
    description: '',
    author: '樊晓光',
    organization: '烟台山医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/07-樊晓光-烟台山医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935750547.jpg'
  },
  {
    id: 'video_07',
    title: '母亲节重视绝经后骨质疏松',
    description: '',
    author: '和雅',
    organization: '烟台山医院郑州大学第五附属医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/08-和雅-郑州大学第五附属医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935804153.jpg'
  },
  {
    id: 'video_08',
    title: '别让时光偷走妈妈的"骨"力',
    description: '',
    author: '张义文',
    organization: '周口骨科医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/09-张义文-周口骨科医院.mp4',
    projectTheme: '疾病诊疗前沿进展',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746935847425.jpg'
  },
  {
    id: 'video_09',
    title: '母亲节关爱妈妈骨骼健康',
    description: '',
    author: '张玉苗',
    organization: '西电集团医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/10 -张玉苗- 西电集团医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936077535.jpg'
  },
  {
    id: 'video_10',
    title: '家里有老人患有骨质疏松症，除了常规的基础治疗和药物治疗，我们作为子女还应该在日常生活中进行一些护理和预防跌',
    description: '',
    author: '师钟丽',
    organization: '浙江大学医学院附属第二医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/11 -师钟丽 -浙江大学医学院附属第二医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936124276.jpg'
  },
  {
    id: 'video_11',
    title: '妈妈骨量告急？这份"护骨攻略"趁早安排！',
    description: '',
    author: '文开莲',
    organization: '眉山市人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/12-文开莲-眉山市人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936182311.jpg'
  },
  {
    id: 'video_12',
    title: '母亲节关爱妈妈骨骼健康',
    description: '',
    author: '陈洁',
    organization: '西南医科大学附属医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/13-陈洁-西南医科大学附属医院.mp4',
    projectTheme: '血液、造血器官、免疫系统疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936226043.jpg'
  },
  {
    id: 'video_13',
    title: '骨质疏松的生活方式的改变',
    description: '',
    author: '王鑫',
    organization: '绍兴市人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/14-王鑫-绍兴市人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936259103.jpg'
  },
  {
    id: 'video_14',
    title: '骨质疏松症的预防',
    description: '',
    author: '卿培东',
    organization: '绵阳市骨科医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/15-卿培东-绵阳市骨科医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936300039.jpg'
  },
  {
    id: 'video_15',
    title: '女性骨松的危害',
    description: '',
    author: '何文静',
    organization: '江西省人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/16-何文静-江西省人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936346307.jpg'
  },
  {
    id: 'video_16',
    title: '爱妈妈，从预防骨质疏松开始',
    description: '',
    author: '陈江伟',
    organization: '南昌大学第一附属医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/17-陈江伟-南昌大学第一附属医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936379828.jpg'
  },
  {
    id: 'video_17',
    title: '谈谈骨质疏松这个病',
    description: '',
    author: '胡学军',
    organization: '肇庆市第一人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/18-胡学军-肇庆市第一人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936434342.jpg'
  },
  {
    id: 'video_18',
    title: '关注老年女性骨质疏松',
    description: '',
    author: '莫教彬',
    organization: '龙岩人民医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/19-莫教彬-龙岩人民医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936471491.jpg'
  },
  {
    id: 'video_19',
    title: '母亲节最好的礼物：别让她的骨头"悄悄变脆"',
    description: '',
    author: '郭海婷',
    organization: '汕头大学医学院第二附属医院',
    url: 'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/2025/05/09/20-郭海婷-汕头大学医学院第二附属医院.mp4',
    projectTheme: '肌肉骨骼系统和结缔组织疾病',
    poster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/1746936523133.jpg'
  },
];

export function getVideoById(id) {
  return allVideos.find(video => video.id === id);
} 